module.exports = {
    SELECT_PRICE: "SELECT_PRICE",
    SELECT_PLAN: "SELECT_PLAN",
    CATEGORIES_PRODUCTS: "CATEGORIES_PRODUCTS",
    PRODUCTS_SALE: "PRODUCTS_SALE",
    PRODUCT_SALE_ADD: "PRODUCT_SALE_ADD",
    PRODUCT_SALE_QUANTITY: "PRODUCT_SALE_QUANTITY",
    PRODUCT_SALE_DELETE: "PRODUCT_SALE_DELETE",
    TOTAL_SALE: "TOTAL_SALE",
    SET_SUBSCRIPTION: "SET_SUBSCRIPTION",
    PAYMENT_DIALOG: "PAYMENT_DIALOG",
    OPEN_MODAL_PRINTER_SETTINGS: "OPEN_MODAL_PRINTER_SETTINGS",
    OPEN_MODAL_PRODUCT_INGREDIENTS: "OPEN_MODAL_PRODUCT_INGREDIENTS",
    OPEN_MODAL_RECIPES_PRODUCTS_PRE_MAKE: "OPEN_MODAL_RECIPES_PRODUCTS_PRE_MAKE",
    SHOW_TOAST: "SHOW_TOAST",
    SHOW_ALERT: "SHOW_ALERT",
    SHOW_QUESTION_DIALOG: "SHOW_QUESTION_DIALOG",
    FIND_CLIENT_MODAL: "FIND_CLIENT_MODAL",
    CLIENT_DIALOG: "CLIENT_DIALOG",
    SELECT_CLIENT: "SELECT_CLIENT",
    PROVIDER_DIALOG: "PROVIDER_DIALOG",
    PROVIDER_SELECT: "PROVIDER_SELECT",
    DYNAMIC_TABLE_LIST: "DYNAMIC_TABLE_LIST",
    DYNAMIC_TABLE_LIST_ADD_OR_UPDATE: "DYNAMIC_TABLE_LIST_ADD_OR_UPDATE",
    DYNAMIC_TABLE_LIST_DELETE: "DYNAMIC_TABLE_LIST_DELETE",
    DYNAMIC_TABLE_EVENT: "DYNAMIC_TABLE_EVENT",
    SIMPLE_TABLE_LIST: "SIMPLE_TABLE_LIST",
    SIMPLE_TABLE_LIST_ADD_OR_UPDATE: "SIMPLE_TABLE_LIST_ADD_OR_UPDATE",
    SIMPLE_TABLE_LIST_DELETE: "SIMPLE_TABLE_LIST_DELETE",
    SHOW_CANCEL_SALE_ALERT: "SHOW_CANCEL_SALE_ALERT",
    SALE_CANCELED: "SALE_CANCELED",
    SHOW_MODAL_INVOICE_BY_EMAIL: "SHOW_MODAL_INVOICE_BY_EMAIL",
    SHOW_QUESTION: "SHOW_QUESTION",

    PRODUCT_DIALOG: "PRODUCT_DIALOG",
    PRODUCT_SELECT: "PRODUCT_SELECT",

    RECIPE_DIALOG: "RECIPE_DIALOG",
    RECIPE_SELECT: "RECIPE_SELECT",

    CATEGORY_DIALOG: "CATEGORY_DIALOG",
    CATEGORY_SELECT: "CATEGORY_SELECT",

    TICKET_DIALOG: "TICKET_DIALOG",
    TICKET_SELECT: "TICKET_SELECT",
    TICKET_CLIENT_DIALOG: "TICKET_CLIENT_DIALOG",
    TICKET_CHECK_DIALOG: "TICKET_CHECK_DIALOG",
    TICKET_EDIT_DIALOG: "TICKET_EDIT_DIALOG",
    TICKET_HISTORY_DIALOG: "TICKET_HISTORY_DIALOG",

    PRODUCT_INGREDIENTS: "PRODUCT_INGREDIENTS",
    PRODUCT_INGREDIENTS_REMOVE: "PRODUCT_INGREDIENTS_REMOVE",
    PRODUCT_INGREDIENTS_ADD: "PRODUCT_INGREDIENTS_ADD",

    COMBO: "COMBO",
    COMBO_REMOVE: "COMBO_REMOVE",
    COMBO_ADD: "COMBO_ADD",

    SECTION_DIALOG: "SECTION_DIALOG",
    SECTION_SELECT: "SECTION_SELECT",

    PAYMENTS_DIALOG: "PAYMENTS_DIALOG",

    PRODUCTS_STOCK: "PRODUCTS_STOCK",
    PRODUCTS_STOCK_UPDATE: "PRODUCTS_STOCK_UPDATE",
    PRODUCTS_STOCK_MODAL: "PRODUCTS_STOCK_MODAL",
    PRODUCT_STOCK_UPDATE_MODAL: "PRODUCT_STOCK_UPDATE_MODAL",

    RECIPES_STOCK: "RECIPES_STOCK",
    RECIPES_STOCK_UPDATE: "RECIPES_STOCK_UPDATE",
    RECIPES_STOCK_MODAL: "RECIPES_STOCK_MODAL",
    RECIPES_STOCK_UPDATE_MODAL: "RECIPES_STOCK_UPDATE_MODAL",

    INGREDIENTS_STOCK_MODAL: "INGREDIENTS_STOCK_MODAL",
    INGREDIENTS_STOCK: "INGREDIENTS_STOCK",
    INGREDIENTS_STOCK_UPDATE: "INGREDIENTS_STOCK_UPDATE",
    INGREDIENT_STOCK_UPDATE_MODAL: "INGREDIENT_STOCK_UPDATE_MODAL",
    INGREDIENT_DIALOG: "INGREDIENT_DIALOG",
    INGREDIENT_SELECT: "INGREDIENT_SELECT",
    EXPENSE_MODAL: "EXPENSE_MODAL",
    EXPENSE_SELECT: "EXPENSE_SELECT",

    PARTIAL_OPEN_BOX_DIALOG: "PARTIAL_OPEN_BOX_DIALOG",
    PARTIAL_OPEN_SELECT: "PARTIAL_OPEN_SELECT",
    COMBO_DIALOG: "COMBO_DIALOG",

    PRODUCT_RECIPES_DIALOG: "PRODUCT_RECIPES_DIALOG",
    PRODUCT_PRICES_DIALOG: "PRODUCT_PRICES_DIALOG",
    PRODUCT_VARIANTS_DIALOG: "PRODUCT_VARIANTS_DIALOG",

    TAX_DIALOG: "TAX_DIALOG",
    TAX_SELECT: "TAX_SELECT",

    WAITER_DIALOG: "WAITER_DIALOG",
    WAITER_SELECT: "WAITER_SELECT",

    EXPENSES_DETAIL_LIST: "EXPENSES_DETAIL_LIST",
    EXPENSES_DETAIL_ADD: "EXPENSES_DETAIL_ADD",
    EXPENSES_DETAIL_DELETE: "EXPENSES_DETAIL_DELETE",

    SALES_TABLE_UPDATE: "SALES_TABLE_UPDATE",
    SALES_OPEN_TABLE: "SALES_OPEN_TABLE",
    OTHER_SALES_MODAL: "OTHER_SALES_MODAL",
    OTHER_SALE_SELECT: "OTHER_SALE_SELECT",

    REPAIR_SHOP_CATEGORY: "repair_shop",
    RESTAURANT_CATEGORY: "restaurant",

    REPAIR_SHOP_ROLES: [
        {
            key: 'technical',
            text: 'Técnico',
            value: 'technical'
        },
    ],

    USER_TYPES:[
        {
            key: 'S',
            text: 'Propietario',
            value: 'S'
        }, {
            key: 'C',
            text: 'Administrador',
            value: 'C'
        }, {
            key: 'G',
            text: 'Vendedor',
            value: 'G'
        }, {
            key: 'F',
            text: 'Financiero',
            value: 'F'
        },
        {
            key: 'call_center',
            text: 'Call Center',
            value: 'call_center'
        }
    ],

    DELIVERY_CHANNEL:[
        {
            key: 'rappi',
            text: 'Rappi',
            value: 'rappi'
        }, {
            key: 'domicilios.com',
            text: 'domicilios.com',
            value: 'domicilios.com'
        }, {
            key: 'gloria-food',
            text: 'Gloria Food',
            value: 'gloria-food'
        }, {
            key: 'whatsapp',
            text: 'Whatsapp',
            value: 'whatsapp'
        }, {
            key: 'telegram',
            text: 'Telegram',
            value: 'telegram'
        },{
            key: 'other',
            text: 'Otro',
            value: 'other'
        },
    ],

    UNITS:[
        {key:'u', value:'u', text:'Unidad', abbr:'Un'},
        {key:'L', value:'L', text:'Litro', abbr:'L'},
        {key:'ml', value:'ml', text:'Mililitro', abbr:'Ml'},
        {key:'Kg', value:'Kg', text:'Kilo', abbr:'Kg'},
        {key:'Gr', value:'Gr', text:'Gramo', abbr:'Gr'},
    ],

    PAYMENT_TYPES: [
        {key: 1, value: 1, text: 'Efectivo'},
        {key: 6, value: 6, text: 'Datáfono'},
        {key: 8, value: 8, text: 'Transferencia Bancaria'},
        {key: 2, value: 2, text: 'Tarj. Crédito'},
        {key: 3, value: 3, text: 'Tarj. Débito'},
        {key: 4, value: 4, text: 'Cheque'},
        {key: 7, value: 7, text: 'ePayco'},
        {key: 9, value: 9, text: 'Rappi'},
        {key: 10, value: 10, text: 'domicilios.com'},
        {key: 11, value: 11, text: 'Nequi'},
        {key: 12, value: 12, text: 'DaviPlata'},
        {key: 5, value: 5, text: 'Otro'},
    ],

    PRODUCT_TYPES: [
        {
            key: 'U',
            text: 'Unico',
            value: 'U'
        },
        {
            key: 'K',
            text: 'Combo',
            value: 'K'
        },
        {
            key: 'V',
            text: 'Variante',
            value: 'V'
        }
    ],

    COMPOUND_TYPES: [
        {
            key: 'I',
            text: 'Ingrediente',
            value: 'I'
        },
        {
            key: 'R',
            text: 'Receta',
            value: 'R'
        }
    ],

    REGIME_TYPES: [
        {
            key: 'NA',
            text: 'No Aplica',
            value: 'NA'
        }, {
            key: 'RC',
            text: 'Régimen Común',
            value: 'RC'
        }, {
            key: 'RS',
            text: 'Régimen Simplificado',
            value: 'RS'
        }
    ],

    EXPENSE_TYPES: [
        { key: 1, value: 1, text: 'Factura' },
        { key: 2, value: 2, text: 'Servicios' },
        { key: 4, value: 4, text: 'Recibos' },
        { key: 5, value: 5, text: 'Nómina' },
        { key: 3, value: 3, text: 'Otros' },
    ],

    CANCEL_ORDER_TYPE: [
        { key: 1, value: 1, text: 'El cliente cambió/canceló el pedido' },
        { key: 2, value: 2, text: 'Pedido fraudulento' },
        { key: 3, value: 3, text: 'Productos no disponibles' },
        { key: 4, value: 4, text: 'Se rechazó el pago' },
        { key: 5, value: 5, text: 'Productos vencidos' },
        { key: 6, value: 6, text: 'Productos en mal estado' },
        { key: 0, value: 0, text: 'Otro' },
    ],

    WAREHOUSE_STOCK_TYPES: [
        { key: 'product', value: 'product', text: 'Producto' },
        { key: 'ingredient', value: 'ingredient', text: 'Ingrediente' },
        { key: 'recipe', value: 'recipe', text: 'Receta' },
    ],

    WAREHOUSE_STOCK_MOVEMENTS: [
        { key: 1, value: 1, text: 'Agregado manualmente' },
        { key: 2, value: 2, text: 'Movido a sucursal' },
        { key: 3, value: 3, text: 'Regresa a bodaga' },
        { key: 4, value: 4, text: 'Dar de baja' },
        { key: 5, value: 5, text: 'Utilizado para preparación de receta' },
    ],

    EXPENSE_PAYMENT_METHODS: [
        { key: 1, value: 1, text: 'Efectivo' },
        { key: 2, value: 2, text: 'Cuenta Bancaría' },
        { key: 4, value: 4, text: 'Tarj. Crédito' },
        { key: 5, value: 5, text: 'Tarj. Débito' },
        { key: 3, value: 3, text: 'Otros' },
    ],

    CHART_COLORS: ['#D0413F', '#E44745', '#E65755', '#E86866', '#EB7977', '#ED8988', '#F09A99'],

    CHOICES_COUNTRIES: [
        { id: 'CO', name: 'Colombia', phone_prefix: '+57' },
        { id: 'EC', name: 'Ecuador', phone_prefix: '+593' },
        { id: 'AR', name: 'Argentina', phone_prefix: '+54' },
        { id: 'CL', name: 'Chile', phone_prefix: '+56' },
        { id: 'PE', name: 'Perú', phone_prefix: '+51' },
        { id: 'MX', name: 'México', phone_prefix: '+52' },
        { id: 'ES', name: 'España', phone_prefix: '+34' },
    ],

    SEND_CHANNELS: [
        { key: 'whatsapp', value: 'whatsapp', text: 'Whatsapp', icon: 'whatsapp' },
        //{ key: 'telegram', value: 'telegram', text: 'Telegram', icon: 'telegram' },
        { key: 'email', value: 'email', text: 'Email', icon: 'mail' },
    ],

    REPAIR_DEVICE_TYPES: [
        {key: 'phone', value: 'phone', text: 'Teléfono', icon: 'mobile alternate'},
        {key: 'computer', value: 'computer', text: 'Computador', icon: 'computer'},
        {key: 'smart_watch', value: 'smart_watch', text: 'Reloj Inteligente', icon: 'clock outline'},
        {key: 'tv', value: 'tv', text: 'Televisor', icon: 'tv'},
        {key: 'other', value: 'other', text: 'Otro', icon: 'wrench'},
    ],

    REPAIR_SHOP_STATUS: [
        {key: 0, icon: 'ambulance', text: 'Por Reparar', value: 0, color: 'gray'},
        {key: 9, icon: 'heartbeat', text: 'En Reparación', value: 9, color: 'yellow'},
        {key: 10, icon: 'heart outline', text: 'Reparado', value: 10, color: 'orange'},
        {key: 11, icon: 'frown outline', text: 'No Tiene Arreglo', value: 11, color: 'red'},
    ],

    SALE_STATE: [
        {key: 1, icon: 'money bill alternate outline', text: 'Abierto', value: 1, color: 'gray'},
        {key: 3, icon: 'check', text: 'Pagado', value: 3, color: 'orange'},
        {key: 2, icon: 'cancel', text: 'Anulado', value: 2, color: 'red'},
    ],

};


// WEBPACK FOOTER //
// ./src/constants.js